<template>
    <div class="content">
        <div class="content_box tableParent public_box">
            <div class="search_box">
                <el-form :inline="true" :model="navForm" class="demo-form-inline">
                    <el-form-item label="车牌号/车架号/设备编号:">
                        <el-input class="width_150" v-model="navForm.keyWord" size="small" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="产品类型:" prop="deviceType" v-if="productTypeData && productTypeData.length > 1">
                        <el-select v-model="navForm.deviceType" placeholder="请选择" size="small" class="width_150" @change="handleDeviceTypeChange">
                            <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.dictName" :value="item.metaData"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="getVehicleInfo" size="small" style="margin-left: 0.2rem">查询</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 轨迹分析 -->
            <div class="vehicle_trip" v-show="activeName == 'first'">
                <vehicle-map :deviceData="detailForm"></vehicle-map>
            </div>
        </div>
    </div>
</template>
<script>
import VehicleMap from '@/components/vehicleMap.vue';
export default {
    components: {
        VehicleMap
    },
    data() {
        return {
            polylineLoading: false,
            initLoaded: false,
            activeName: 'first',
            navForm: {
                company: null,
                keyWord: null,
                // keyWord: '68070032919',
                // keyWord: '14149299861',
                deviceType: null
            },
            detailForm: {
                deviceNumber: null,
                plugginStatus: null,
                deviceType: null
            },
            center: { lng: 116.404269, lat: 39.915378 },
            zoom: 18,
            marker: { showFlag: false },
            positionPoint: {},
            // 车辆图标
            positionIcon: {
                url: require('../../../public/images/msi/online/car_icon.png'),
                size: {
                    width: 24,
                    height: 46
                },
                opts: {
                    anchor: {
                        width: 24,
                        height: 46
                    }
                }
            },
            BMap: null,
            BDmap: null
        };
    },
    computed: {
        productTypeData() {
            let typeData = this.$store.state.common.productTypeData;
            return typeData;
        }
    },
    mounted() {},
    methods: {
        initPageByProductType() {
            if (!this.productTypeData || !this.productTypeData.length) {
                return;
            }
            let defaultDeviceType = this.productTypeData[0].metaData;
            this.productTypeData.forEach((item) => {
                if (item.expandInfo) {
                    defaultDeviceType = item.metaData;
                }
            });
            if (this.navForm.deviceType == null) {
                this.navForm.deviceType = defaultDeviceType;
            }
            if (!this.initLoaded) {
                this.initLoaded = true;
                this.queryCurrentTrip();
            }
        },
        queryCurrentTrip() {
            let pageData = this.$route.query;

            if (!pageData.deviceNumber) {
                this.findVehicleNumber();
            } else {
                this.navForm.keyWord = pageData.deviceNumber;
                this.navForm.deviceType = Number(pageData.deviceType);
                this.getVehicleInfo();
            }
        },
        findVehicleNumber() {
            this.$request({
                method: 'get',
                url: `/ubi/api/vehicle/findTenantSampleVehicle`,
                params: this.navForm.deviceType == 2 ? { deviceType: 1, shortTermRental: true } : this.navForm.deviceType == 1 ? { deviceType: 1, shortTermRental: false } : { deviceType: this.navForm.deviceType }
            }).then((res) => {
                if (res.code == 200) {
                    this.navForm.keyWord = res.data.deviceNumber;
                    this.getVehicleInfo();
                }
            });
        },
        // 切换产品类型
        handleDeviceTypeChange() {
            this.navForm.keyWord = null;
            this.findVehicleNumber();
        },
        // 车辆实时位置
        getVehicleInfo() {
            this.polylineLoading = true;
            this.detailForm = null;
            let locationParams = Object.assign({}, this.navForm);
            if (locationParams.deviceType == 2) {
                locationParams.deviceType = 1;
                locationParams.shortTermRental = true;
            } else if (locationParams.deviceType == 1) {
                locationParams.shortTermRental = false;
            }
            this.$request({
                method: 'get',
                url: `/ubi/api/vehicle/location`,
                params: locationParams
            }).then((res) => {
                this.polylineLoading = false;

                if (res.code == 200 && Object.keys(res.data).length > 0) {
                    this.detailForm = {
                        ...res.data,
                        deviceType: Number(this.navForm.deviceType)
                    };
                } else {
                    this.$message.error('暂无数据！');
                }
            });
        }
    },
    watch: {
        productTypeData: {
            handler() {
                this.initPageByProductType();
            },
            immediate: true
        }
    }
};
</script>
<style lang="less" scoped>
.tableParent {
    height: calc(100vh - 90px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .vehicle_trip {
        flex: 1;
        min-height: 0;
        overflow: hidden;
    }
    .location_box {
        height: 100%;
        overflow: auto;
        .dialog_map {
            width: 100%;
            min-height: 400px;
            height: calc(100vh - 300px);
            // border: 1px solid red;
            #container {
                height: 100% !important;
            }
        }
    }
}
.search_box {
    flex: none;
    margin-bottom: 0;
}
#container {
    width: 100%;
    height: 500px;
    // /deep/ .BMap_pop {
    //     left: 264px !important;
    //     top: 90px !important;
    // }
    /deep/ .BMap_pop p {
        line-height: 18px;
    }
    /deep/ .BMap_pop p:nth-child(3) {
        display: inline-block;
        width: 300px;
    }
}
</style>
